import type { Notebook, NotebookChatTurn } from "./reportTypes"

export const OVERVIEW_TARGET = "__overview__"

export interface ReportRevisionPayload {
  instructions: string
  request_id: string
  expected_revision: number
  section_ids?: string[]
  stream: true
}

export type ReportRevisionEvent =
  | {
      type: "request_started"
      request_id: string
      section_ids: string[]
      turn?: NotebookChatTurn
    }
  | { type: "section_started"; request_id: string; section_id: string }
  | {
      type: "section_delta"
      request_id: string
      section_id: string
      body: string
    }
  | {
      type: "section_final"
      request_id: string
      section_id: string
      notebook: Notebook
      changed: boolean
    }
  | {
      type: "section_error"
      request_id: string
      section_id: string
      error: string
    }
  | {
      type: "request_final"
      request_id: string
      notebook: Notebook
      turn: NotebookChatTurn
    }
  | { type: "error"; request_id: string; error: string }

export type ReportRevisionStream = (
  notebookId: string,
  payload: ReportRevisionPayload,
  onEvent: (event: ReportRevisionEvent) => void,
  signal: AbortSignal,
) => Promise<void>

export interface ReportSectionProgress {
  requestId: string
  status: "queued" | "running" | "saved" | "unchanged" | "failed"
  body?: string
  message?: string
  revision?: number
}
